import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Order, OrderState} from '../../../orders/models';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {ApplicationState} from '../../../application-state/store';
import {OrdersSelectors, OrderStatesSelectors} from '../../../orders/store/selectors';
import {loadIfNotLoaded} from '../../../shared/utilities/observable.utility';
import {OrderStatesActions} from '../../../orders/store';
import {Ticket} from '../../models';
import {TicketsSelectors} from '../../store/selectors';
import {DataRecoveryPriorityModesActions, DataRecoveryPriorityModesEffects} from '../../../master-data/store';
import {DataRecoveryPriorityModesSelectors} from '../../../master-data/store/selectors';
import {DataRecoveryPriorityMode} from '../../../master-data/models';
import {TicketList} from '../../models/ticket-list.interface';

@Component({
  selector: 'app-ticket-priority-mode-select',
  styleUrls: ['./ticket-priority-mode-select.component.scss'],
  template: `
    <div [formGroup]="formGroup">

      <ng-select
        [items]="items$|async"
        bindLabel="name"
        [searchable]="true"
        [loading]="isLoading$| async"
        bindValue="name"
        [clearable]="true"
        [searchFn]="findItem"
        placeholder="Datenrettungsmodus"
        [formControlName]="fieldName"
        (change)="setSelectedItem($event)">

        <ng-template ng-label-tmp let-item="item">
          {{item.name}}
          <span *ngIf="getOrderCount(item.name)>0">({{getOrderCount(item.name)}}x)</span>

        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          {{item.name}}
          <span *ngIf="getOrderCount(item.name)>0">({{getOrderCount(item.name)}}x)</span>
        </ng-template>
      </ng-select>
    </div>
  `

})
export class TicketPriorityModeSelectComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() fieldName: string;
  @Output() updateSelectedObject: EventEmitter<DataRecoveryPriorityMode> = new EventEmitter<DataRecoveryPriorityMode>();

  items$: Observable<Array<DataRecoveryPriorityMode>>;
  isLoading$: Observable<boolean>;
  selectedItem: DataRecoveryPriorityMode;

  tickets: TicketList[];


  constructor(private store$: Store<ApplicationState>) {
  }

  ngOnInit(): void {
    this.items$ = this.store$.select(DataRecoveryPriorityModesSelectors.sList);
    this.isLoading$ = this.store$.select(DataRecoveryPriorityModesSelectors.isLoading);
    loadIfNotLoaded(this.store$, DataRecoveryPriorityModesSelectors.isLoaded,
      DataRecoveryPriorityModesActions.ReadDataRecoveryPriorityModes());
    this.store$.select(TicketsSelectors.sList).subscribe((tickets) => {
      this.tickets = tickets;
    });
  }

  getOrderCount(statusName: string): number {
    return this.tickets.filter((e: TicketList) => e.order?.dataRecoveryPriorityMode?.name === statusName).length || -1;
  }

  setSelectedItem(element: DataRecoveryPriorityMode): void {
    this.selectedItem = element;
    this.updateSelectedObject.emit(element);
  }

  findItem(term: string, item: DataRecoveryPriorityMode): boolean {
    const parts = term.split(' ');
    return parts.every(t => {
      return (item.name.toLowerCase().indexOf(t.toLowerCase()) > -1);
    });
  }

}
